import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
const { colors, devices, fontSizes, spaces } = theme;

const StyledWrapperBannerContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: ${colors.blue[50]};
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    z-index: -1;
  }
  @media ${devices.laptopM} {
    padding-left: ${spaces.large2X}px;
    padding-right: ${spaces.large2X}px;
    &::before {
      border-bottom-left-radius: 50px;
      border-bottom-right-radius: 50px;
    }
  }
  @media ${devices.tablet} {
    position: unset;
    width: auto;
    display: block;

    &::before {
      display: none;
    }
  }
`;
const StyledBannerContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  max-width: ${spaces.large24X * 10 + 80}px;
  padding-top: ${spaces.large2X}px;
  padding-bottom: ${spaces.large4X + 2}px;

  @media ${devices.tablet} {
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
    padding-top: ${spaces.regular}px;
    padding-bottom: ${spaces.regular}px;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: ${colors.blue[50]};
      border-bottom-left-radius: 32px;
      border-bottom-right-radius: 32px;
      z-index: -1;
    }
  }
`;

const StyledTopBannerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
`;

const StyledBannerImageContainer = styled.div`
  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}

  @media ${devices.tablet} {
    display: none;
  }
`;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledMobileBannerImageContainer = styled(
  forwardRef(({ hideImageMobile, ...props }, ref) => (
    <div ref={ref} {...props} />
  ))
)`
  display: none;

  img {
    width: 64%;
  }

  @media ${devices.tablet} {
    display: block;
    text-align: center;
    margin-bottom: ${spaces.regular}px;

    ${({ hideImageMobile }) =>
      hideImageMobile &&
      css`
        display: none;
      `}
  }
`;

const StyledBannerContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${devices.tablet} {
    width: 100%;
  }
`;

const StyledBannerTopSection = styled.div`
  margin-bottom: ${spaces.regular}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.large}px;
  font-weight: 400;
  color: ${colors.gray[700]};

  a {
    color: ${colors.blue[500]};
  }

  @media ${devices.tablet} {
    font-size: ${fontSizes.regular}px;
  }
`;

const StyledBottomContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .childrenDescription {
    width: 228px;
  }
  @media ${devices.tablet} {
    .childrenDescription {
      width: 100%;
      text-align: center;
      font-size: ${fontSizes.regular}px;
    }
  }
`;
const StyledRecentryTrademarkContainerDesktop = styled.div`
  @media ${devices.tablet} {
    display: none;
  }
`;
const StyledRecentryTrademarkContainerMobile = styled.div`
  display: none;
  @media ${devices.tablet} {
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
    padding-top: ${spaces.regular}px;
    padding-bottom: ${spaces.regular}px;
    display: flex;
  }
`;
const MainBannerSection = ({
  imgSrc,
  topSection,
  bottomSection,
  recentlyTrademarked,
  hideImageMobile,
}) => {
  return (
    <StyledWrapperBannerContainer>
      <StyledBannerContainer>
        <StyledTopBannerContainer>
          <StyledBannerContentContainer>
            <StyledBannerTopSection>{topSection}</StyledBannerTopSection>
            <StyledMobileBannerImageContainer
              width={!bottomSection ? 270 : undefined}
              hideImageMobile={hideImageMobile}
            >
              <picture>
                <source srcSet={imgSrc} type="image/png" />
                <img src={imgSrc} alt="Banner image" />
              </picture>
            </StyledMobileBannerImageContainer>
            {bottomSection && (
              <StyledBottomContainer>{bottomSection}</StyledBottomContainer>
            )}
          </StyledBannerContentContainer>
          <StyledBannerImageContainer>
            <picture>
              <source srcSet={imgSrc} type="image/png" />
              <img src={imgSrc} alt="Banner image" />
            </picture>
          </StyledBannerImageContainer>
        </StyledTopBannerContainer>
        {recentlyTrademarked && (
          <StyledRecentryTrademarkContainerDesktop>
            {recentlyTrademarked}
          </StyledRecentryTrademarkContainerDesktop>
        )}
      </StyledBannerContainer>
      {recentlyTrademarked && (
        <StyledRecentryTrademarkContainerMobile>
          {recentlyTrademarked}
        </StyledRecentryTrademarkContainerMobile>
      )}
    </StyledWrapperBannerContainer>
  );
};

MainBannerSection.propTypes = {
  imgSrc: PropTypes.string,
  topSection: PropTypes.node,
  bottomSection: PropTypes.node,
  recentlyTrademarked: PropTypes.node,
  hideImageMobile: PropTypes.bool,
};

export default MainBannerSection;
